module.exports = __webpack_public_path__ + "img/SCN-vibrating-wire-quadratic-formula-12pt.a8f7d30a.svg";